import React from 'react'
import { Link } from 'react-router'

class Subscribe extends React.Component {
	render() {
		let className = 'wide-section-newsletter wide-section'
		let text = 'Subscribe here to get instant access to our resources:'
		let action = 'https://adventist.us8.list-manage.com/subscribe/post?u=25d434a61d5a9048967cc2a91&amp;id=0164fb122b'

		if ( this.props.sidebar ) {
			className = 'side-newsletter'
		}

		if ( this.props.text ) {
			text = this.props.text
		}

		if ( this.props.action ) {
			action = this.props.action
		}

		return (
			<div className={ className }>
				<div className="-inner">
					<h4>{ text }</h4>

					<form action={ action } method="post" target="_blank">
						<div className="-input">
							<input placeholder="Your Name" type="text" name="FNAME" className="required" id="mce-FNAME" />
						</div>

						<div className="-input">
							<input placeholder="Your Email" type="text" name="EMAIL" className="required" id="mce-EMAIL" />
						</div>

						<div className="-button">
							<button className="button -send" name="subscribe" id="mc-embedded-subscribe">Subscribe</button>
						</div>
					</form>
				</div>
			</div>
		)
	}
}

export default Subscribe



// WEBPACK FOOTER //
// ./components/Subscribe/Subscribe.jsx